<!-- 
	Auth
	role: Public 
	Displays login or registration component for unauthorized users
-->

<template>
	<div class="auth flex items-center md:flex-row flex-col justify-around">
		<div
			class="
        text-side
        w-screen
        sm:w-6/12
        text-center
        py-6
        sm:py-0 sm:text-left
        text-white
      "
		>
			
			<div class="text-5xl font-bold py-4 gold">
				Welcome to the WinWin Staff Lottery Player Profile Portal
			</div>
			<div>
				<span v-if="formState === false">Register now for the WinWin Staff Lottery Player Profile to view your participation activity</span>
				<span v-if="formState === true">Log In to your WinWin Staff Lottery Player Profile to view your participation activity</span>
			</div>
			
			<CustomButton @click="formSwitch()">
				<span v-if="formState === true">Log In</span>
				<span v-else>Register</span>
			</CustomButton>
		</div>
		<div class="form-side text-center w-screen sm:w-96 text-white">
			<div v-if="formState === true">
				<div class="py-4 border-spacer">
					<div class="text-xl font-bold pt-6 sm:pt-0">
						Register to Activate Account
					</div>
					<div class="gold">
						Already have an Account?<br />
						<span @click="formSwitch()" class="font-bold cursor-pointer"
							>Login</span
						>
					</div>
				</div>
				<Register />
			</div>
			<div v-else>
				<div class="py-4 border-spacer">
					<div class="text-xl font-bold pt-6 sm:pt-0">Log In</div>
					<div class="gold">
						First time here?<br />
						<span @click="formSwitch()" class="font-bold cursor-pointer"
							>Activate your account today.</span
						>
					</div>
				</div>
				<Login />
			</div>
			<div class="px-8 py-4 text-sm border-spacer-t">
				By creating an account, you agree to accept our
				<span @click="openAccordion()" class="gold font-bold"
					>Privacy Policy</span
				>
				<div v-if="accordion" class="accordion">
					<div class="pb-4">
						The personal information collected by WinWin Staff Lottery will be
						used by the Lottery and participating Foundations to process ticket
						orders, notify winners, send out lottery information in 2022 and
						future years, and to contact you regarding marketing and fundraising
						efforts, research, promotional information and events, through
						email, phone or mail.
					</div>
					<div class="pb-4">
						Prize winners' name, ticket nunmbers, city and facility designation
						will be posted at winwinstafflottery.ca and on promotional materials
						and/or emails.
					</div>
					<div>
						Should you have any concerns about how we collect, use or disclose
						your personal information, please contact us by email at
						<a
							href="mailto:customerservice@winwinstafflottery.ca"
							class="winwin-aqua"
							>customerservice@winwinstafflottery.ca</a
						>
						or call
						<a href="tel:+18445946946" class="winwin-aqua"
							>1 (844) 594 - 6946</a
						>.
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Register from "@/components/Register";
	import Login from "@/components/Login";
	import CustomButton from "@/components/CustomButton";

	import { useStore } from "vuex";

	import { computed } from "vue";

	export default {
		name: "Auth",
		components: {
			Register,
			Login,
			CustomButton,
		},
		data() {
			return {
				register: "",
				accordion: false,
			};
		},
		setup() {
			const store = useStore();

			let formState = computed(function() {
				return store.state.register;
			});

			return { formState };
		},
		methods: {
			formSwitch: function() {
				// switch form from login or registration component
				this.register = !this.register;
				this.$store.commit("formSwitch", this.register);
			},

			openAccordion: function() {
				this.accordion = !this.accordion;
			},
		},
	};
</script>

<style scoped>
	.form-side {
		background: linear-gradient(0deg, rgba(26, 31, 86, 0.85), #000000);
	}

	.gold {
		color: #e5d876;
	}

	.border-spacer {
		border-bottom: 1px solid #eaeaea;
		border-bottom-color: rgba(255, 255, 255, 0.1);
	}

	.border-spacer-t {
		border-top: 1px solid #eaeaea;
		border-top-color: rgba(255, 255, 255, 0.1);
	}

	.accordion {
		padding: 15px 5px;
		line-height: 1.5;
		font-size: 0.85rem;
		width: 100%;
	}
</style>
